import { useState } from "react";
import { Form } from "react-bootstrap";

export const FormTextField = (param) => {
  const [value, setValue] = useState(null);

  return (
    <Form.Group className={param.className} controlId={param.id}>
      <Form.Label>{param.label}</Form.Label>
      <Form.Control
        type={param.type}
        name={param.name}
        placeholder={param.placeholder}
        className="input-placeholder"
        value={value}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        style={{
          backgroundColor: "transparent",
          color: "white",
          appearance: "none",
          MozAppearance: "textfield",
          borderColor: param.error ? "red" : "white",
        }}
        {...param.control}
      />
      {param.error && <p className="text-danger">{param.error.message}</p>}

      <style>
        {`  .input-placeholder::placeholder {
              color: white;
              opacity: 0.7;
              
          `}
      </style>
    </Form.Group>
  );
};

export default FormTextField;
